import HttpService from '../utility/httpService';
class notificationsService {
    async getList(skip, take) {
        const response = await HttpService.postList("/Admin/CMS_Users/GetAdminNotifications", { skip, take });
        return response;
    }
}

export default new notificationsService();